import * as types from './action-types';

import { defineAction } from 'store/common/action-helpers';

export const fetchCompanyTeamMemberConnectionsForAdminByPrettyId = {
  request: ({ prettyId }) =>
    defineAction(types.FETCH_COMPANY_TEAM_MEMBER_CONNECTIONS_FOR_ADMIN_BY_PRETTY_ID.REQUEST, {
      prettyId,
    }),
  start: ({ prettyId }) =>
    defineAction(types.FETCH_COMPANY_TEAM_MEMBER_CONNECTIONS_FOR_ADMIN_BY_PRETTY_ID.START, {
      prettyId,
    }),
  success: ({ prettyId }) =>
    defineAction(types.FETCH_COMPANY_TEAM_MEMBER_CONNECTIONS_FOR_ADMIN_BY_PRETTY_ID.SUCCESS, {
      prettyId,
    }),
  failure: ({ prettyId, error }) =>
    defineAction(types.FETCH_COMPANY_TEAM_MEMBER_CONNECTIONS_FOR_ADMIN_BY_PRETTY_ID.FAILURE, {
      prettyId,
      error,
    }),
};

export const inviteTeamMemberToCompany = {
  request: (values, form, modal) =>
    defineAction(types.INVITE_TEAM_MEMBER_TO_COMPANY.REQUEST, values, { form, modal }),
  start: values => defineAction(types.INVITE_TEAM_MEMBER_TO_COMPANY.START, values),
  success: ({ teamMemberConnection, prettyId }) =>
    defineAction(types.INVITE_TEAM_MEMBER_TO_COMPANY.SUCCESS, {
      teamMemberConnection,
      prettyId,
    }),
  failure: ({ email, designation, prettyId, error }) =>
    defineAction(types.INVITE_TEAM_MEMBER_TO_COMPANY.FAILURE, {
      email,
      designation,
      prettyId,
      error,
    }),
};

export const updateTeamMemberToCompany = {
  request: (values, form, modal) =>
    defineAction(types.UPDATE_TEAM_MEMBER_TO_COMPANY.REQUEST, values, { form, modal }),
  start: values => defineAction(types.UPDATE_TEAM_MEMBER_TO_COMPANY.START, values),
  success: ({ teamMemberConnection, prettyId }) =>
    defineAction(types.UPDATE_TEAM_MEMBER_TO_COMPANY.SUCCESS, {
      teamMemberConnection,
      prettyId,
    }),
  failure: ({ error }) =>
    defineAction(types.UPDATE_TEAM_MEMBER_TO_COMPANY.FAILURE, {
      error,
    }),
};

export const deleteTeamMemberFromCompany = {
  request: ({ teamMemberId, prettyId }) =>
    defineAction(types.DELETE_TEAM_MEMBER_FROM_COMPANY.REQUEST, {
      teamMemberId,
      prettyId,
    }),
  start: ({ teamMemberId, prettyId }) =>
    defineAction(types.DELETE_TEAM_MEMBER_FROM_COMPANY.START, {
      teamMemberId,
      prettyId,
    }),
  success: ({ teamMemberId, prettyId }) =>
    defineAction(types.DELETE_TEAM_MEMBER_FROM_COMPANY.SUCCESS, {
      teamMemberId,
      prettyId,
    }),
  failure: ({ teamMemberId, prettyId, error }) =>
    defineAction(types.DELETE_TEAM_MEMBER_FROM_COMPANY.FAILURE, {
      teamMemberId,
      prettyId,
      error,
    }),
};



// WEBPACK FOOTER //
// ./src/store/features/admin/companies/team-members/actions.js